export default __webpack_public_path__ + "static/media/services_3_5t.247883e7.svg";